<template>
  <CModal
    :title="title"
    :color="color"
    size="lg"
    :show.sync="accountAccessModal"
  >
    <CRow>
      <CCol md="6">
        <CInput
          label="RFC de la cuenta:"
          :value="account && account.fiscal ? account.fiscal.rfc : ''"
          readonly
        />
      </CCol>
      <CCol md="6">
        <CInput
          label="Nombre de la cuenta:"
          :value="account ? account.name : ''"
          readonly
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <CSelect
          label="Usuario revendedor (Partner):"
          :isValid="checkIfValid('partner_user_id')"
          :value.sync="$v.form.partner_user_id.$model"
          :options="partnerUsersOptions"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol md="6">
        <CInput
          label="Correo de acceso (cliente):"
          :lazy="false"
          :value.sync="$v.form.email.$model"
          placeholder=""
          autocomplete="email"
          :isValid="checkIfValid('email')"
          invalidFeedback="Ingrese un correo valido."
        />
      </CCol>
      <CCol md="6">
        <CInput
          label="Contraseña de acceso (cliente):"
          type="password"
          :lazy="false"
          :value.sync="$v.form.password.$model"
          placeholder=""
          autocomplete="new-password"
          :isValid="checkIfValid('password')"
          invalidFeedback="Si se modifica, la contraseña debe tener al menos 6 caracteres."
        />
      </CCol>
    </CRow>
    <template #footer>
      <CButton @click="closeModal" color="secondary">Cancelar</CButton>
      <CButton @click="saveAccess" :color="color">Guardar</CButton>
    </template>
  </CModal>
</template>

<script>
import account_ws from '../../../services/account';

import { validationMixin } from 'vuelidate';
import { required, minLength, email } from 'vuelidate/lib/validators';

const PASSWORD_MASK = '**********';

export default {
  name: 'AccountAccessModal',
  props: {},
  data() {
    return {
      accountAccessModal: false,
      title: 'Configurar Acceso de Cuenta',
      color: 'info',
      account: null,
      submitted: false,
      form: {
        partner_user_id: '',
        email: '',
        password: PASSWORD_MASK
      },
      partnerUsers: [],
      partnerUsersOptions: []
    }
  },
  methods: {
    async addAccountAccessModal(account) {
      this.account = account;
      this.submitted = false;
      this.accountAccessModal = true;

      const usersResponse = await account_ws.getPartnerUsers();
      if (usersResponse.type === 'success') {
        this.partnerUsers = usersResponse.data;
        this.partnerUsersOptions = await this.$parseSelectOptionsOrdered(this.partnerUsers, 'id', 'display_name:email', [{label: 'Seleccione...', value: ''}]);
      }

      this.form = {
        partner_user_id: account.partner_user_id ? account.partner_user_id : '',
        email: account.user ? account.user.email : '',
        password: PASSWORD_MASK
      };

      this.$v.$reset();
    },
    saveAccess() {
      this.submitted = true;
      this.$v.form.$touch();

      if (this.$v.form.$invalid) {
        return;
      }

      const payload = {
        partner_user_id: this.form.partner_user_id,
        email: this.form.email
      };

      if (this.form.password !== PASSWORD_MASK && (this.form.password || '').trim() !== '') {
        payload.password = this.form.password;
      }

      this.$emit('updateAccountAccess', payload);
    },
    closeModal() {
      this.accountAccessModal = false;
    },
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName];
      if (!field.$dirty) {
        return null;
      }

      return !field.$invalid;
    }
  },
  computed: {
    isValid() { return !this.$v.form.$invalid; }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      partner_user_id: {
        required
      },
      email: {
        required,
        email
      },
      password: {
        minLength: minLength(6)
      }
    }
  }
}
</script>
